import { getFlagIcon } from '@utils/common';
import { useEffect, useState } from 'react';

const useGetCountryFlag = (event?: { country?: string; country_code?: string }) => {
    const [flagUrl, setFlagUrl] = useState('');
    useEffect(() => {
        const countryCode = event?.country_code ?? event?.country;
        if (countryCode) {
            getFlagIcon(
                countryCode.toLowerCase(),
                (path) => setFlagUrl(path.default),
                (error) => console.log(error)
            );
        }
    }, [event?.country, event?.country_code]);

    return flagUrl;
};

export { useGetCountryFlag };
